import { defineNuxtPlugin, useUserSession } from "#imports";
export default defineNuxtPlugin({
  enforce: 'pre',
  handler: async (nuxtApp) => {
    if (!nuxtApp.payload.serverRendered) {
      await useUserSession().fetch();
    } else if (Boolean(nuxtApp.payload.prerenderedAt) || Boolean(nuxtApp.payload.isCached)) {
      await useUserSession().fetch();
    }
  }
});
